@if (showTalentPoolsIcon) {
  <rt-icon name="nav-talent-pools-outline" size="small-x"></rt-icon>
}
